import React from 'react';
import { motion } from 'framer-motion';
import { PackageIcon, TrophyIcon, LayoutTemplateIcon } from 'lucide-react';
const bonuses = [{
  icon: PackageIcon,
  title: '100 Productos Validados',
  desc: 'Banco completo de productos digitales listos para subir y vender desde el día 1.'
}, {
  icon: TrophyIcon,
  title: 'De Genérico a Ganador',
  desc: 'El método para diferenciarte y posicionar tu tienda en un mercado saturado.'
}, {
  icon: LayoutTemplateIcon,
  title: 'Conversion Landing Pro',
  desc: 'Plantilla de landing page optimizada para convertir. Lista en minutos.'
}];
export function Bonuses() {
  return <section className="py-12 md:py-20 bg-dark-800/50 border-y border-white/5 relative" data-id="element-16">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-17">
        <div className="text-center mb-8 md:mb-10" data-id="element-18">
          <h2 className="text-gold-500 font-display text-base md:text-2xl tracking-widest uppercase mb-2 md:mb-3" data-id="element-19">
            Incluidos Gratis
          </h2>
          <p className="text-2xl md:text-5xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-20">
            3 Bonos Estratégicos
          </p>
        </div>

        {/* Bonuses row — same layout mobile & desktop */}
        <div className="grid grid-cols-3 gap-2 md:gap-5" data-id="element-21">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} whileHover={{
          y: -5
        }} className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-xl md:rounded-2xl p-3 pt-5 md:p-6 md:pt-8 border border-gold-500/30 relative shadow-[0_0_20px_rgba(212,175,55,0.05)] flex flex-col items-center text-center" data-id="element-22">
              <div className="absolute -top-2.5 md:-top-3 left-1/2 -translate-x-1/2 bg-gold-500 text-black font-display px-2.5 md:px-3 py-0.5 rounded-full text-[9px] md:text-xs tracking-widest uppercase shadow-lg whitespace-nowrap" data-id="element-23">
                Bono {i + 1}
              </div>
              <div className="absolute top-1.5 right-1.5 md:top-3 md:right-3 bg-dark-900 border border-gold-500/50 text-gold-400 font-bold px-1.5 md:px-2 py-0.5 rounded text-[8px] md:text-[10px] uppercase tracking-wider" data-id="element-24">
                Free
              </div>

              <motion.div whileHover={{
            rotate: [0, -8, 8, 0]
          }} transition={{
            duration: 0.5
          }} className="w-10 h-10 md:w-14 md:h-14 bg-gold-500/10 rounded-lg md:rounded-xl flex items-center justify-center border border-gold-500/20 mb-2 md:mb-4" data-id="element-25">
                <bonus.icon className="text-gold-500 w-5 h-5 md:w-7 md:h-7" data-id="element-26" />
              </motion.div>

              <h3 className="text-[11px] md:text-base font-bold text-white mb-1 md:mb-2 leading-tight" data-id="element-27">
                {bonus.title}
              </h3>
              <p className="text-gray-400 leading-snug text-[10px] md:text-sm" data-id="element-28">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-6 md:mt-10 text-center bg-dark-900 py-3 md:py-5 px-4 md:px-6 rounded-xl border border-gold-500/20 max-w-2xl mx-auto" data-id="element-29">
          <p className="text-sm md:text-2xl font-display text-white uppercase tracking-wide" data-id="element-30">
            Valor de los bonos:{' '}
            <span className="line-through text-gray-500 mr-1" data-id="element-31">$89.000</span>{' '}
            <span className="text-gold-500" data-id="element-32">— GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}